<template>
    <div class="load-more-wrapper" ref="scroll_box" @touchstart="touchStart($event)" @touchend="touchEnd($event)">
        <div class="inner">
            <slot></slot>
            <div class="load-more" v-show="enableLoadMore">
                <img v-if="isLoading" class="load-img" src="../../static/icons/loading.gif" alt="">
                {{loadMoreText}}
            </div>
            <!-- <div class="load-end" v-show="!enableLoadMore">~没有更多啦~</div> -->
        </div>
    </div>
</template>
<script>
export default {
    name: "LoadMore",
    props: {
        enableLoadMore: {
            type: Boolean,
            default: true
        },
        onLoadMore: {
            type: Function,
            default: undefined,
            require: false
        },
        search_input_height:{
          type: Number,
          default: 0
        },
        filter_height:{
          type: Number,
          default: 0
        }
    },
    data() {
        return {
            loadMoreText: "上拉加载更多",
            startX: 0,
            startY: 0,
            isLoading: false,
        }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll,true)
    },
  methods: {
        handleScroll(val) {
          if (this.$el.scrollTop > this.search_input_height * 1.5) {
            this.$emit('searchscikty',true)
          } else {
            this.$emit('searchscikty',false)
          }
          if (this.$el.scrollTop > this.filter_height) {
            this.$emit('isfilterscikty',true)
          } else {
            this.$emit('isfilterscikty',false)
          }
        },
        touchStart(e) {
            this.startY = e.targetTouches[0].pageY;
            this.startX = e.targetTouches[0].pageX;
        },
        scrollToEnd(e) {
            let scrollHeight = this.$el.scrollHeight;
            let clientHeight = this.$el.clientHeight;
            let scrollTop = this.$el.scrollTop;
            this.$emit('handleScroll',scrollTop)
            if (scrollTop + clientHeight >= scrollHeight-2 && this.enableLoadMore) {
                this.doLoadMore()
            }
        },
        touchEnd(e) {
            let scrollTop = this.$el.scrollTop;
            this.$emit('handleScroll',scrollTop)
            if (this.isLoading) {
                return;
            }
            let endX = e.changedTouches[0].pageX,
                    endY = e.changedTouches[0].pageY,
                    dy = this.startY - endY,
                    dx = endX - this.startX;
            if(Math.abs(dx) < 2 && Math.abs(dy) < 2) {
                return;
            }
            if (endY < this.startY) {
                this.scrollToEnd(e)
            }
        },
        doLoadMore() {
            this.isLoading = true
            this.loadMoreText = '加载中...'
            this.onLoadMore(this.loadDone);
        },
        loadDone() {
            this.isLoading = false;
            this.loadMoreText = '上拉加载更多'
        },
        destroyed () {
          // 离开该页面需要移除这个监听的事件，不然会报错
          window.removeEventListener('scroll', this.handleScroll)
        }
    }
}
</script>
<style lang="css" scoped>
.load-img{
    width: 0.9rem;
    height: 0.9rem;
    vertical-align: middle;
    margin-right: 0.5rem;
}
.load-more, .load-end {
    font-size: 0.7rem;
    margin: 0.5rem 0 1rem;
    color:rgba(0,0,0,.25);
    text-align: center;
}
.load-more{
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/loadMore.vue